const dashboard = {
  dashboard: {
    description: '안녕하세요 {{userName}}님!',
    noUpcoming: '스케줄을 예약해주세요.',
    daysLeft: '예정된 위성 연결까지 {{days}}일 남았습니다.',
    tabs: {
      monitoring: '모니터링',
      paymentAnalytics: '결제 통계'
    },
    paymentAnalytics: {
      periodOptions: {
        sixMonths: '6개월',
        oneMonth: '1개월',
        oneWeek: '1주'
      },
      overview: {
        title: 'Overview',
        totalPayments: '총 결제 건수',
        totalAmount: '총 결제 금액',
        pending: '입금 대기',
        completed: '결제 완료',
        cancellationReq: '취소 요청',
        refunded: '환불완료',
        countUnit: '건'
      },
      priceMonitor: {
        title: 'Price Monitor',
        costBySatellite: '위성별 사용료',
        usageByAntenna: '안테나별 사용 비율',
        usageByPayment: '결제수단별 사용비율',
        costTooltipLabel: '비용'
      },
      paymentMethods: {
        bank_transfer: '계좌이체',
        card_payment: '카드결제',
        free_usage: '무료이용'
      }
    }
  }
};

export default dashboard;